import * as types from './types'

export default {
  [types.SET_USER_LOGGED]: function(state, isUserLogged) {
    state.userLogged = isUserLogged
  },
  [types.SET_USER_INFORMATIONS]: function(state, payload) {
    state.userInformations = payload
  },
  [types.REGISTER_USER]: function(state, payload) {
    state.registeringUser.email = payload.email
    state.registeringUser.validated = payload.validated
  },
  [types.SET_SUBSCRIPTION_STATUS]: function(state, payload) {
    state.subscription.type = payload.type
    state.subscription.expirationDate = payload.expirationDate || null
    state.subscription.hasUnsubscribed = payload.hasUnsubscribed || false
  },
  [types.LOGOUT]: function(state) {
    state.userLogged = false
    state.userInformations = null
    state.subscription.type = false
    state.subscription.expirationDate = null
  },
  [types.SET_ID_TOKEN]: function(state, idToken) {
    state.idToken = idToken
  },
  [types.SET_COMMANDS]: function(state, commands) {
    state.commands = commands
  },
  [types.SET_KEEP_OFFLINE_MODE]: function(state, keepOfflineMode) {
    state.keepOfflineMode = keepOfflineMode
  }
}
